/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_TaglineInputs */

const en_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS, or one cross-platform codebase for both.`)
};

const ar_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أندرويد أو iOS أو كود واحد للمنصتين.`)
};

const bn_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS, বা দুটোর জন্যই একটি ক্রস-প্ল্যাটফর্ম কোডবেস।`)
};

const de_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS oder eine plattformübergreifende Codebasis für beide.`)
};

const es_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS o una base de código multiplataforma para ambos.`)
};

const fr_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS ou une base de code multiplateforme pour les deux.`)
};

const pt_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS ou uma base de código multiplataforma para ambos.`)
};

const zh_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android、iOS 或两者的一个跨平台代码库。`)
};

const tr_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS veya her ikisi için de platformlar arası kod tabanı.`)
};

const ru_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS или одна кроссплатформенная кодовая база для обоих.`)
};

const pl_svc_mobile_app_development_tagline = /** @type {(inputs: Svc_Mobile_App_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android, iOS lub jedna wieloplatformowa baza kodu dla obu.`)
};

/**
* | output |
* | --- |
* | "Android, iOS, or one cross-platform codebase for both." |
*
* @param {Svc_Mobile_App_Development_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_tagline = /** @type {((inputs?: Svc_Mobile_App_Development_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_tagline(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_tagline(inputs)
	if (locale === "de") return de_svc_mobile_app_development_tagline(inputs)
	if (locale === "es") return es_svc_mobile_app_development_tagline(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_tagline(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_tagline(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_tagline(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_tagline(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_tagline(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_tagline(inputs)
	return en_svc_mobile_app_development_tagline(inputs)
});
export { svc_mobile_app_development_tagline as "svc_mobile-app-development_tagline" }